import React, { useEffect } from 'react';
import Layout from '../components/Layout';

const ContactUsPage = () => {
    useEffect(() => {
        document.title = "Contact Us | KAR – Kelowna Auto Rentals";
        document.querySelector('meta[name="description"]')?.setAttribute("content",
            "Get in touch with KAR – Kelowna Auto Rentals. Email info@karrentals.ca or call (250) 575-6041. Available 7 days a week, 9 AM–5 PM PST."
        );
    }, []);

    return (
        <Layout>
            <div id="contactus" className="container mx-auto p-6 my-4">
                {/* Main container for the section */}
                <div className="relative h-[56rem] bg-cover bg-center rounded-2xl overflow-hidden">
                    {/* Background image for small screens */}
                    <div 
                        className="absolute inset-0 bg-cover bg-center sm:hidden z-0"
                    ></div>

                    {/* Background image for larger screens */}
                    <div 
                        className="absolute inset-0 bg-cover bg-center hidden sm:block z-0"
                        style={{ backgroundImage: 'url("/mercedes.png")' }}
                    ></div>

                    {/* Overlay to darken the image */}
                    <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

                    {/* Heading */}
                    <h1 className="relative text-2xl sm:text-4xl font-bold text-white border-b-4 border-white flex justify-evenly p-6 bg-opacity-75 bg-black z-20">
                        Contact Us
                    </h1>

                    {/* Scrollable Content */}
                    <div 
                        className="absolute top-32 left-1/2 transform -translate-x-1/2 w-11/12 bg-opacity-75 bg-black rounded-2xl p-4 text-white z-20 h-[calc(100%-12rem)] overflow-auto"
                    >
                        <p className="text-lg sm:text-2xl mb-6">
                            We’re here to help make your journey as smooth and stress-free as possible. Whether you have questions about your rental, need assistance with a booking, or have special requests, our team is ready to assist.
                        </p>
                        <h2 className="text-xl sm:text-3xl font-bold mt-6 mb-4">Get in Touch</h2>
                        <ul className="text-lg sm:text-2xl space-y-2">
                            <li><strong>Email:</strong>info@karrentals.ca</li>
                            <li><strong>Phone:</strong> +1 (250) 575-6041</li>
                            <li><strong>Business Hours:</strong> 9:00 AM – 5:00 PM PST, 7 days a week</li>
                        </ul>

                        <h2 className="text-xl sm:text-3xl font-bold mt-6 mb-4">Have a Question?</h2>
                        <p className="text-lg sm:text-2xl mb-2">
                            Check out our FAQs for quick answers to common questions, or reach out directly.
                        </p>
                        <h2 className="text-xl sm:text-3xl font-bold mt-6 mb-4">Looking for Support After Hours?</h2>
                        <p className="text-lg sm:text-2xl mb-2">
                            If you require assistance outside of our business hours, please refer to the roadside service instructions provided with your rental agreement.
                        </p>
                        <h2 className="text-xl sm:text-3xl font-bold mt-6 mb-4">We Value Your Feedback</h2>
                        <p className="text-lg sm:text-2xl">
                            At KAR, we’re committed to continuous improvement. If you have suggestions or feedback about your experience, don’t hesitate to contact us. Your input helps us serve you better.
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ContactUsPage;
